import { JsonPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { User } from '../../../Models/user';
import { UserService } from '../../../Services/user.service';
import { Utility } from '../../../Utilities/utility';
import { environment } from '../../../../environments/environment';



@Component({
  selector: 'app-create-session',
  templateUrl: './create-session.component.html',
  styleUrls: ['./create-session.component.scss']
})
export class CreateSessionComponent implements OnInit {
  private EmployeeId :number
  private utility: Utility
  constructor(
    private route: ActivatedRoute
    ,private cookieService:CookieService
    ,private _UserService: UserService
    ) { 
      this.utility = new Utility(this.cookieService);
      this.EmployeeId = 0;
    }


  ngOnInit() {
    
    this.route.queryParams
      .subscribe(params => {
        if(params.value != null){
          let QueryString :[] = params.value.split("~");          
          this.EmployeeId = QueryString[QueryString.length-1];
          let SessionId :string = "";
          QueryString.forEach(element => {
            if(element != this.EmployeeId.toString())
              SessionId = SessionId + element;
          });
          //cookie expire time added by rahul yadav on 6/9/2021
          this.cookieService.set('SessionId', SessionId , this.utility.CookieExpiryTime, undefined, environment.cookieDomain);
          this.GetUserDetail()
         
        }
        
      }
    );
  }

  private GetUserDetail(){
    this._UserService.GetUserDetail(this.EmployeeId).toPromise()
    .then((d) => {
       //cookie expire time added by rahul yadav on 6/9/2021
      this.cookieService.set('UD', btoa(JSON.stringify(d)) , this.utility.CookieExpiryTime, undefined, environment.cookieDomain);
      window.close();
    },(error) => {
      this.utility.Error(error);
      //  window.location.href = "https://localhost:8083";
       window.close();
    });

  }

}
